import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@fontsource/noto-sans/latin-400.css";
import "@fontsource/noto-sans/latin-ext-400.css";
import "@fontsource/noto-sans/latin-500.css";
import "@fontsource/noto-sans/latin-ext-500.css";
import "@fontsource/noto-sans/latin-600.css";
import "@fontsource/noto-sans/latin-ext-600.css";
import "@fontsource/noto-sans/latin-700.css";
import "@fontsource/noto-sans/latin-ext-700.css";
import "@fontsource/noto-sans/latin-800.css";
import "@fontsource/noto-sans/latin-ext-800.css";

import { App } from "./App";
import { initializeWordinariusAppCheck } from "./platform/firebaseAppCheck";
import "./styles.css";
import "./dilhocam-app.css";

void initializeWordinariusAppCheck();

if ("serviceWorker" in navigator && import.meta.env.PROD) {
  window.addEventListener("load", () => {
    void navigator.serviceWorker.register("/app/sw.js", { scope: "/app/" });
  });
}

const root = document.getElementById("root");

if (!root) {
  throw new Error("wordinarius_web_root_missing");
}

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
